import { render } from "./DashboardRegistrationsRow.vue?vue&type=template&id=6dbeaac8&scoped=true&ts=true"
import script from "./DashboardRegistrationsRow.vue?vue&type=script&lang=ts"
export * from "./DashboardRegistrationsRow.vue?vue&type=script&lang=ts"

import "./DashboardRegistrationsRow.vue?vue&type=style&index=0&id=6dbeaac8&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dbeaac8"]])

export default __exports__